import {
  ListGroup, Row, Col, Button
} from "react-bootstrap";
import { useStateMachine } from "little-state-machine";
import { updateSelectedUser } from "actions/updateSelectedUser";
import { updateUserHistoryFilter } from "actions/updateUserHistoryFilter";
import { useNavigate } from "react-router-dom";
import { UserIcon } from "components/UserIcon/UserIcon";
import { IUser } from "interfaces/models/IUser";
import { UserStatusTypeValue } from "interfaces/models/UserStatusType";
import { initialUserHistoryFilter } from "modules/InitialUserHistoryFilter";

interface UserItemProps {
  user: IUser;
}

const UserItem = ({ user, ...props } : UserItemProps) => {
  const navigate = useNavigate();

  const { actions } = useStateMachine({
    updateSelectedUser,
    updateUserHistoryFilter
  });

  const handleManageUser = () => {
    actions.updateSelectedUser(user);
    navigate("/manageuser");
  };

  const handleUserHistory = () => {
    actions.updateUserHistoryFilter(initialUserHistoryFilter());
    actions.updateSelectedUser(user);
    navigate("/userhistory");
  };

  return (
    <ListGroup.Item {...props}>
      <Row className="align-items-center" data-testid="userItemRow">
        <Col xs={6} lg={2} className="user-name">
          <Row className="align-items-center">
            <Col xs={2}>
              <UserIcon isFederatedUser={user.isFederatedUser!} isPortalAdminUser={user.isPortalAdmin!} />
            </Col>
            <Col xs={10}>
              <span data-testid="username" className="title">{user.username}</span>
            </Col>
          </Row>

        </Col>
        <Col lg={4} className="email-address d-none d-lg-block">
          <span data-testid="emailAddress" className="title">{user.emailAddress}</span>
        </Col>
        <Col lg={2} className="groups-applications d-none d-xl-flex justify-content-center">
          <span data-testid="groupsApplications" className="title">
            {user.groups ? user.groups.length : 0}
            {" "}
            /
            {" "}
            {user.applicationCount}
          </span>
        </Col>
        <Col lg={2} className="status d-none d-xl-flex justify-content-center">
          <span data-testid="status" className="title">{user.requests ? "REQUESTS" : UserStatusTypeValue[user.status!]}</span>
        </Col>
        <Col xs={6} lg={2} className="d-flex justify-content-end">
          <Button
            data-testid="btnManageUser"
            variant="primary"
            className="right-margin-small"
            aria-label="Manage User"
            onClick={() => handleManageUser()}
          >
            Manage
          </Button>
          <Button
            data-testid="btnUserHistory"
            variant="primary"
            className="right-margin-small"
            aria-label="User History"
            onClick={() => handleUserHistory()}
          >
            History
          </Button>
        </Col>
      </Row>
    </ListGroup.Item>
  );
};

export default UserItem;
